//main Grid class
import { getAllInstancesByName } from "../../core";
import Component from "../component.abstract";
import { isParent } from "../helpers/html-utils";
import TabLayout from "../tablayout/tablayout";
import GridContents from "./grid-contents";
import GridSides from "./grid-sides";

export default class Grid extends Component {
  private initDesk = window.innerWidth > 767;
  private loaded = false;
  private sidekick: GridSides;
  constructor(private props: unknown, element: HTMLElement) {
    super(props,element);
  }
  mounted(): void {
    const children = this.element.children;
    // dispatch the inner elements from between sides and contents
    const contents = [];
    const sides = [];
    const odd = [];
    const even = [];
    for (let i = 0; i < children.length; i++) {
      // by default there is a dispatch that is done if the grid has no side and no contents part
      const child = children[i];
      if (i % 2 == 0) {
        odd.push(child);
      } else {
        even.push(child);
      }
      if (child.classList.contains("side")) {
        sides.push(child);
      } else {
        contents.push(child);
      }
    }

    new GridContents(this.element);
    
    // if there is some elements that are specified as side ones, we can tell the grid that there is thing to do with the sidebar
    // else, just do it as a simple block div
    // create the sheets with components union
    if (sides.length) {
      this.sidekick = new GridSides(
        <HTMLElement[]>sides,
        this.element,
        this.initDesk
      );
      // listen to the sidebar load to tell the listeners that the grid is loaded
      PubSub.subscribe("GridSides-loaded", () => {
        this.loaded = true;
        PubSub.publish("Grid-loaded");
      });

      const tabLayoutInstances: TabLayout[] = getAllInstancesByName("TabLayout");
      for(const instance of tabLayoutInstances) {
        if(isParent(this.element, instance.content)) {
           PubSub.subscribe("Tablayout.changed", (msg:string, instance:TabLayout) => {
              if(instance.isShowing() && window.innerWidth > 767) {
                this.sidekick.reload()
              }
           })
        }
      }
    } else {
      // tell the listeners that the grid is loaded
      this.loaded = true;
      PubSub.publish("Grid-loaded");
    }
  }
}
